/**
 * Each item its own days (the owner, 2026-10-24: "1 L of G daily and 1 HG on alternate days").
 *
 * An agreement's line may carry a cycle of per-day units counted from the agreement's first day (CD-26): [1, 1] every day,
 * [1, 0] alternate days, seven entries lined up with the weekdays from the first day. The server builds the same cycles
 * (sales.item_cycle, 141500); onboarding sends them itself through sales.plan_lines' CYCLE plan.
 */
export type Every = 'DAILY' | 'ALTERNATE' | 'WEEKDAYS';

export const EVERY_OPTIONS: { value: Every; label: string }[] = [
  { value: 'DAILY', label: 'Every day' }, { value: 'ALTERNATE', label: 'Alternate days' }, { value: 'WEEKDAYS', label: 'Chosen weekdays' },
];

/** ISO weekday (1 Monday … 7 Sunday) of a YYYY-MM-DD date. */
export const isoWeekday = (date: string) => ((new Date(`${date}T00:00:00Z`).getUTCDay() + 6) % 7) + 1;

/** The line's cycle from the first day: every day is [q, q] so it can sit in a cycle agreement beside other lines. */
export function cycleFor(every: Every, quantity: number, weekdays: number[], start: string): number[] {
  if (every === 'ALTERNATE') return [quantity, 0];
  if (every === 'WEEKDAYS') {
    const first = isoWeekday(start);
    return Array.from({ length: 7 }, (_, i) => (weekdays.includes(((first - 1 + i) % 7) + 1) ? quantity : 0));
  }
  return [quantity, quantity];
}

const WD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const everyLabel = (every: Every, weekdays: number[]) =>
  every === 'DAILY' ? 'every day' : every === 'ALTERNATE' ? 'alternate days' : `on ${[...weekdays].sort().map((d) => WD[d - 1]).join(' ')}`;
